import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { DrawingAdditionalToursRequestDto, DrawingAdditionalToursResponseDto } from "app/models";
import { DrawingsService, NotificationService } from "app/services";

@Component({
    selector: 'second-tour-12',
    templateUrl: 'second-tour-12.page.html',
    styleUrls: ['second-tour-12.page.scss'],
})
export class SecondTour12Page implements OnInit {
    
    formGroup: FormGroup;

    result: DrawingAdditionalToursResponseDto[];

    isProcessing: boolean = false;
    
    constructor(private notificationService: NotificationService,
        private drawingService: DrawingsService) { }

    ngOnInit(): void {
        this.buildForm();
    }

    onSubmit() {
        
        if (!this.formGroup.controls.tour1FormControl.value ||
            !this.formGroup.controls.tour2FormControl.value ||
            !this.formGroup.controls.tour3FormControl.value ||
            !this.formGroup.controls.tour4FormControl.value ||
            !this.formGroup.controls.tour5FormControl.value ) {
                this.notificationService.showError('Не выбраны ИД.');
                return;
            }

        let request = new DrawingAdditionalToursRequestDto();
        request.matchDay1 = this.formGroup.controls.tour1FormControl.value;
        request.matchDay2 = this.formGroup.controls.tour2FormControl.value;
        request.matchDay3 = this.formGroup.controls.tour3FormControl.value;
        request.matchDay4 = this.formGroup.controls.tour4FormControl.value;
        request.matchDay5 = this.formGroup.controls.tour5FormControl.value;

        this.isProcessing = true;

        this.drawingService.addAdditionalToursFor12Teams(request)
            .subscribe(result => {
                this.result = result;
                this.isProcessing = false;
                this.notificationService.showSuccess('Дополнительные туры внесены в расписание.')
            }, error => {
                this.isProcessing = false;
                this.notificationService.showSuccess('Ошибка сохранения дополнительных туров.')
            })

    }

    private buildForm() {
        this.formGroup = new FormGroup({
            tour1FormControl: new FormControl(),
            tour2FormControl: new FormControl(),
            tour3FormControl: new FormControl(),
            tour4FormControl: new FormControl(),
            tour5FormControl: new FormControl(),
        });
    }
}